import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import queryString from 'query-string';

import CompositeAlert from '../../core/CompositeAlert';
import AbnSearch from '../../abn/abnsearch/AbnSearch';
import StepContainer from '../steps/StepContainer';
import Auth from '../../../api/auth';
import contexts from '../../../contexts';
import { digitalRegistrationLoadedEvent, gtmUserJourneyEvent } from '../../../utils/gtmUtils';
import { GTM_EVENT_TYPE_USER_JOURNEY, QUERY_PARAMS } from '../../../constants';
import urlUtils from '../../../utils/urlutils';

class BusinessDetails extends PureComponent {
  constructor(props) {
    super(props);

    this.abnRef = React.createRef();

    this.state = {
      isTrustee: false,
    };

    this.handleBusinessSelection = this.handleBusinessSelection.bind(this);
    this.handleNewSearch = this.handleNewSearch.bind(this);
    this.handleIsTrustee = this.handleIsTrustee.bind(this);
    this.isAcnSearch = this.isAcnSearch.bind(this);
  }

  componentDidMount() {
    const parsedSearch = queryString.parse(this.props.location.search);
    let recipientGcContactId = parsedSearch.recipient_gc_contact_id || '';
    if (!recipientGcContactId) {
      recipientGcContactId = urlUtils.getSessionQuerystring(QUERY_PARAMS.RECIPIENT_GC_CONTACT_ID);
    }
    this.props.verifyInvitation(this.props.portal, recipientGcContactId);
    this.props.resetValidationResult();
    const gtmUserJourneyEventObject = {
      eventType: GTM_EVENT_TYPE_USER_JOURNEY.REGO_START,
    };
    gtmUserJourneyEvent(gtmUserJourneyEventObject);
    digitalRegistrationLoadedEvent();
    const { user } = this.context;
    if (!user) {
      if (Auth.isLoggedIn()) {
        Auth.logout();
      }
    }
  }

  isAcnSearch() {
    if (
      this.abnRef.current &&
      this.abnRef.current.state.searchResult.keyword &&
      this.props.validationResult.abn
    ) {
      return this.props.validationResult.abn.acn === this.abnRef.current.state.searchResult.keyword;
    }
    return false;
  }

  handleBusinessSelection(data) {
    this.setState({ isTrustee: data.isTrustee });
    this.props.isEligible(data, data.isTrustee);
  }

  handleNewSearch() {
    this.props.resetValidationResult();
  }

  handleIsTrustee(e) {
    const { checked } = e.target;
    const { validationResult, isEligible } = this.props;

    this.setState({ isTrustee: checked });
    isEligible(validationResult.abn, checked);
  }

  render() {
    const { validationResult, continueToNextStep, searchAbn, delay } = this.props;
    const { isTrustee } = this.state;

    const isTrusteeAcnSearch = this.isAcnSearch(this.abnRef, validationResult);

    return (
      <StepContainer
        title="Your business details"
        subtitle="Start typing your ABN or Business Name or Trading Name"
        isSubmitVisible={validationResult.isEligible}
        isSubmitDisabled={!validationResult.isEligible}
        submitButtonAdditionalCssClassName="ga-reg-business"
        onSubmit={continueToNextStep}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <AbnSearch
              ref={this.abnRef}
              onItemSelected={this.handleBusinessSelection}
              onNewSearch={this.handleNewSearch}
              search={searchAbn}
              data-testid="abnsearch"
              delay={delay}
            />
          </Grid>
          {validationResult.isValidated && (
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <CompositeAlert
                    variant={validationResult.isEligible ? 'success' : 'error'}
                    message={validationResult.message}
                  />
                </Grid>
                {validationResult.isCompany && (
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="isTrustee"
                          color="primary"
                          inputProps={{
                            'aria-label': 'uncontrolled-checkbox',
                          }}
                          onChange={this.handleIsTrustee}
                          checked={isTrustee || isTrusteeAcnSearch}
                          disabled={isTrusteeAcnSearch}
                          data-testid="istrustee"
                        />
                      }
                      label="This business is acting as a trustee"
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          )}
        </Grid>
      </StepContainer>
    );
  }
}

BusinessDetails.propTypes = {
  validationResult: PropTypes.object.isRequired,
  isEligible: PropTypes.func.isRequired,
  resetValidationResult: PropTypes.func.isRequired,
  continueToNextStep: PropTypes.func.isRequired,
  searchAbn: PropTypes.func.isRequired,
  verifyInvitation: PropTypes.func.isRequired,
  delay: PropTypes.number,
  portal: PropTypes.string.isRequired,
};

BusinessDetails.defaultProps = {
  delay: 500,
};

BusinessDetails.contextType = contexts.LoginContext;

export default BusinessDetails;
